import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import type { RemarkBoxValue } from './types';
import { RemarkContent } from '.';
import {
  useUpdateNomination,
  type ApplicationRemarkType,
} from '../../../graphql';
import { Alert, type AlertDetails } from '../../../../../components';

type RemarkProps = {
  remarks: string[];
  isViewMode?: boolean;
  returnedRemarks: ApplicationRemarkType[];
  refetchRemark: () => void;
};

export const Remark: React.FunctionComponent<RemarkProps> = props => {
  const { nominationId } = useParams();
  const { refetchRemark, isViewMode = false, remarks, returnedRemarks } = props;

  const initialValues: RemarkBoxValue = {
    scalar: remarks,
  };

  const [openAlert, setOpenAlert] = useState(false);
  const [alertDetails, setAlertDetails] = useState<AlertDetails>({
    alertContent: '',
    alertType: 'error',
  });

  const updateNomination = useUpdateNomination(refetchRemark);
  const handleSubmit = async (value: RemarkBoxValue): Promise<void> => {
    const { scalar } = value;
    const variables = {
      id: nominationId,
      input: {
        remarks: scalar,
      },
    };
    try {
      await updateNomination({
        variables,
      });
      setAlertDetails({
        alertContent: 'Saved Remarks Successfully.',
        alertType: 'success',
      });
      refetchRemark();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (error: any) {
      setAlertDetails({
        alertContent: `Saved Remarks Failed.` + (error as Error).message,
        alertType: 'error',
      });
    }
    setOpenAlert(true);
  };

  return (
    <div>
      <Alert
        openAlert={openAlert}
        setOpenAlert={setOpenAlert}
        alertDetails={alertDetails}
      />
      <RemarkContent
        isViewMode={isViewMode}
        initialValues={initialValues}
        returnedRemarks={returnedRemarks}
        onSubmit={handleSubmit}
      />
    </div>
  );
};
